import { render, staticRenderFns } from "./AlterarDadosApoio.vue?vue&type=template&id=e20d2f5a"
import script from "./AlterarDadosApoio.vue?vue&type=script&lang=js"
export * from "./AlterarDadosApoio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports